import { ReportWithLossMemberForRankingResponse } from "lib/worker/api/report_wis_loss_member_for_ranking";
import Img from "react-cloudimage-responsive";

interface Props {
  transaction: ReportWithLossMemberForRankingResponse[];
}

function AgentStatistic(props: Props) {
  const trunover = (): number => {
    let value = 0.0;
    props.transaction.forEach((v) => {
      value += v.Turnover ?? 0;
    });
    return value;
  };
  const betcount = (): number => {
    let value = 0.0;
    props.transaction.forEach((v) => {
      value += v.BetCount ?? 0;
    });
    return value;
  };
  const betAmount = (): number => {
    let value = 0.0;
    props.transaction.forEach((v) => {
      value += v.Bet ?? 0;
    });
    return value;
  };
  const commission = (): number => {
    let value = 0.0;
    props.transaction.forEach((v) => {
      value += v.Com ?? 0;
    });
    return value;
  };

  return (
    <>
      <div className="row" style={{ marginTop: -15 }}>
        <div className="col-6 col-md-6 col-lg-4 col-xl-3">
          <div
            className="card-ufa-category card border-ufa-grey"
            style={{
              borderRadius: 5,
              marginTop: 15,
              padding: "0px 0px 15px 0px",
            }}
          >
            <div className="">
              <div className="color-font-card">
                <div>
                  <div
                    className=""
                    style={{
                      marginLeft: 5,
                      marginTop: 5,
                    }}
                  >
                    <label
                      style={{
                        float: "left",
                        marginTop: 10,
                        marginLeft: 10,
                        fontSize: 16,
                        opacity: 0.5,
                      }}
                    >
                      เทิร์นโอเวอร์
                    </label>
                  </div>
                  <div
                    className=""
                    style={{
                      width: 40,
                      height: 1,
                      marginRight: 0,
                      marginLeft: 0,
                      marginTop: 0,
                      float: "right",
                    }}
                  >
                    <Img
                      ratio={1}
                      style={{
                        height: 75,
                        padding: 0,
                        marginTop: 0,
                        opacity: 0.3,
                      }}
                      src="icon-bet-static.png"
                      alt="เทิร์นโอเวอร์"
                    ></Img>
                  </div>

                  <div style={{ clear: "both" }}></div>
                </div>
              </div>
              <div className="margin-top-10" style={{ marginLeft: 15 }}>
                <label style={{ fontSize: 18 }}>
                  {trunover().format(2, 0)}
                </label>
              </div>
            </div>
          </div>
        </div>
        <div className="col-6 col-md-6 col-lg-4 col-xl-2">
          <div
            className="card-ufa-category card border-ufa-grey"
            style={{
              borderRadius: 5,
              marginTop: 15,
              padding: "0px 0px 15px 0px",
            }}
          >
            <div className="">
              <div className="color-font-card">
                <div>
                  <div
                    className=""
                    style={{
                      marginLeft: 5,
                      marginTop: 5,
                    }}
                  >
                    <label
                      style={{
                        float: "left",
                        marginTop: 10,
                        marginLeft: 10,
                        fontSize: 16,
                        opacity: 0.5,
                      }}
                    >
                      จำนวนรอบ
                    </label>
                  </div>
                  <div
                    className=""
                    style={{
                      width: 40,
                      height: 1,
                      marginRight: 0,
                      marginLeft: 0,
                      marginTop: 0,
                      float: "right",
                    }}
                  >
                    <Img
                      ratio={1}
                      style={{
                        height: 75,
                        padding: 0,
                        marginTop: 0,
                        opacity: 0.3,
                      }}
                      src="icon-footer-lotto.png"
                      alt="จำนวนรอบ"
                    ></Img>
                  </div>

                  <div style={{ clear: "both" }}></div>
                </div>
              </div>
              <div className="margin-top-10" style={{ marginLeft: 15 }}>
                <label style={{ fontSize: 18 }}>
                  {betcount().format(0, 0)}
                </label>
              </div>
            </div>
          </div>
        </div>
        <div className="col-6 col-md-6 col-lg-4 col-xl-2">
          <div
            className="card-ufa-category card border-ufa-grey"
            style={{
              borderRadius: 5,
              marginTop: 15,
              padding: "0px 0px 15px 0px",
            }}
          >
            <div className="">
              <div className="color-font-card">
                <div>
                  <div
                    className=""
                    style={{
                      marginLeft: 5,
                      marginTop: 5,
                    }}
                  >
                    <label
                      style={{
                        float: "left",
                        marginTop: 10,
                        marginLeft: 10,
                        fontSize: 16,
                        opacity: 0.5,
                      }}
                    >
                      ชนะ/แพ้
                    </label>
                  </div>
                  <div
                    className=""
                    style={{
                      width: 40,
                      height: 1,
                      marginRight: 0,
                      marginLeft: 0,
                      marginTop: 0,
                      float: "right",
                    }}
                  >
                    <Img
                      ratio={1}
                      style={{
                        height: 75,
                        padding: 0,
                        marginTop: 0,
                        opacity: 0.3,
                      }}
                      src="icon-footer-allgame.png"
                      alt="รายได้"
                    ></Img>
                  </div>

                  <div style={{ clear: "both" }}></div>
                </div>
              </div>
              <div className="margin-top-10" style={{ marginLeft: 15 }}>
                <label style={{ fontSize: 18 }}>
                  {betAmount().format(2, 0)}
                </label>
              </div>
            </div>
          </div>
        </div>
        <div className="col-6 col-md-6 col-lg-6 col-xl-2">
          <div
            className="card-ufa-category card border-ufa-grey"
            style={{
              borderRadius: 5,
              marginTop: 15,
              padding: "0px 0px 15px 0px",
            }}
          >
            <div className="">
              <div className="color-font-card">
                <div>
                  <div
                    className=""
                    style={{
                      marginLeft: 5,
                      marginTop: 5,
                    }}
                  >
                    <label
                      style={{
                        float: "left",
                        marginTop: 10,
                        marginLeft: 10,
                        fontSize: 16,
                        opacity: 0.5,
                      }}
                    >
                      ผู้เล่น
                    </label>
                  </div>
                  <div
                    className=""
                    style={{
                      width: 40,
                      height: 1,
                      marginRight: 0,
                      marginLeft: 0,
                      marginTop: 0,
                      float: "right",
                    }}
                  >
                    <Img
                      ratio={1}
                      style={{
                        height: 75,
                        padding: 0,
                        marginTop: 0,
                        opacity: 0.3,
                      }}
                      src="icon-player-static.png"
                      alt="ตัวแทน"
                    ></Img>
                  </div>

                  <div style={{ clear: "both" }}></div>
                </div>
              </div>
              <div className="margin-top-10" style={{ marginLeft: 15 }}>
                <label style={{ fontSize: 18 }}>
                  {props.transaction.length.format(0, 0)}
                </label>
              </div>
            </div>
          </div>
        </div>
        <div className="col-12 col-md-6 col-lg-6 col-xl-3">
          <div
            className="card-ufa-category card border-ufa-grey"
            style={{
              borderRadius: 5,
              marginTop: 15,
              padding: "0px 0px 15px 0px",
            }}
          >
            <div className="">
              <div className="color-font-card">
                <div>
                  <div
                    className=""
                    style={{
                      marginLeft: 5,
                      marginTop: 5,
                    }}
                  >
                    <label
                      style={{
                        float: "left",
                        marginTop: 10,
                        marginLeft: 10,
                        fontSize: 16,
                        opacity: 0.5,
                      }}
                    >
                      คอมมิชชั่น
                    </label>
                  </div>
                  <div
                    className=""
                    style={{
                      width: 40,
                      height: 1,
                      marginRight: 0,
                      marginLeft: 0,
                      marginTop: 0,
                      float: "right",
                    }}
                  >
                    <Img
                      ratio={1}
                      style={{
                        height: 75,
                        padding: 0,
                        marginTop: 0,
                        opacity: 0.3,
                      }}
                      src="icon-coin-static.png"
                      alt="คอมมิชชั่น"
                    ></Img>
                  </div>

                  <div style={{ clear: "both" }}></div>
                </div>
              </div>
              <div className="margin-top-10" style={{ marginLeft: 15 }}>
                <label style={{ fontSize: 18 }}>
                  {commission().format(2, 0)}
                </label>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default AgentStatistic;
